import { useState } from 'react';
import { useLazyQueryWebhookDeliveryLogs, DELIVERY_LOG_STATUS } from '@ion/api';

const INITIAL_FILTERS = {
  eventType: null,
  status: DELIVERY_LOG_STATUS.ALL,
};

export default function useDeliveryLogsTable({ webhookConfigId }) {
  const [filters, setFilters] = useState(INITIAL_FILTERS);

  const [getDeliveryLogs, { data, pagination, loading }] = useLazyQueryWebhookDeliveryLogs({
    webhookConfigId,
    filters,
  });

  return {
    filters,
    onFilterChange: setFilters,
    onFetchPage: getDeliveryLogs,
    data,
    pagination,
    loading,
  };
}
